


































import {Vue, Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {
  GetPresignedUrlForSignaturePayload,
  GetPresignedUrlForSignatureResponse,
  UploadSignatureImagePayload,
  UpdateSignaturePayload,
} from '@/store/modules/taxrefund/types'

import PageFooter from '@/components/PageFooter.vue'
import LoadingComponent from '@/components/LoadingComponent.vue'

import useSignaturePad from './utils/useSignaturePad'
import BaseModal from '../common/BaseModal.vue'
import ErrorModal from './ErrorModal.vue'

const taxrefund = namespace('taxrefund')
const biz = namespace('biz')

const {init, clearCanvas, exportToImage} = useSignaturePad

@Component({
  components: {
    BaseModal,
    PageFooter,
    ErrorModal,
    LoadingComponent,
  }
})
export default class SignatureModal extends Vue {
  @Prop({default: ''}) userName: string
  @biz.State('id') bizId: string | null
  @biz.State('name') bizName: string
  @taxrefund.State('id') taxRefundId: string | null
  @taxrefund.Action('getPresignedUrlForSignature') getPresignedUrlForSignature: (payload: GetPresignedUrlForSignaturePayload)
  => Promise<GetPresignedUrlForSignatureResponse>
  @taxrefund.Action('uploadSignatureImage') uploadSignatureImage: (payload: UploadSignatureImagePayload) => Promise<any>
  isActive = false
  @taxrefund.Action('updateSignature') updateSignature: (payload: UpdateSignaturePayload) => Promise<any>

  isShowErrorModal: boolean = false
  fetching: boolean = false

  mounted() {
    init('signature-pad', this.updateActive,  this.userName, this.bizName)
  }
  updateActive(target: boolean) {
    this.isActive = target
  }
  handleClose() {
    clearCanvas()
    this.$emit('close')
  }
  handleCloseError() {
    this.isShowErrorModal = false
    clearCanvas()
  }
  handleClearCanvas() {
    clearCanvas()
  }
  showError() {
    this.isShowErrorModal = true
    this.fetching = false
  }
  async handleNext() {
    this.fetching = true
    const presignedUrlPayload: GetPresignedUrlForSignaturePayload = {
      bizId: this.bizId || '',
      taxRefundId: this.taxRefundId || '',
    }
    const responsePresignedUrl = await this.getPresignedUrlForSignature(presignedUrlPayload)
    if(!responsePresignedUrl) {
      this.showError()
      return
    }

    const uploadPayload: UploadSignatureImagePayload = {
      presignedUrl: {
        url: responsePresignedUrl.presignedUrl.url,
        fields: {
          key: responsePresignedUrl.presignedUrl.fields.key,
          policy: responsePresignedUrl.presignedUrl.fields.policy,
          xAmzAlgorithm: responsePresignedUrl.presignedUrl.fields.xAmzAlgorithm,
          xAmzCredential: responsePresignedUrl.presignedUrl.fields.xAmzCredential,
          xAmzDate: responsePresignedUrl.presignedUrl.fields.xAmzDate,
          xAmzSignature:responsePresignedUrl.presignedUrl.fields.xAmzSignature,
        }
      },
      file: exportToImage()
    }
    const responseUpload = await this.uploadSignatureImage(uploadPayload)
    if(responseUpload?.status !== 204) {
      this.showError()
      return
    }

    const updatePayload: UpdateSignaturePayload = {
      bizId: this.bizId || '',
      taxRefundId: this.taxRefundId || '',
      presignedUrlKey: responsePresignedUrl.key,
    }
    const responseUpdate = await this.updateSignature(updatePayload)
    if(!responseUpdate) {
      this.showError()
      return
    }

    this.$emit('next')
  }
  isDisabled() {
    return !this.isActive
  }
}
